import { paperClasses } from '@mui/material';
import Alert, { alertClasses } from '@mui/material/Alert';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import { useTheme } from '@mui/material/styles';
import { t } from 'i18next';

interface ErrorPartProps {
  message: string;
  onStartNewChat: () => void;
}

export default function ErrorPart({ message, onStartNewChat }: ErrorPartProps) {
  const theme = useTheme();

  return (
    <Alert
      severity="error"
      sx={{
        [`&.${paperClasses.root}`]: {
          bgcolor: theme.semantic.statusErrorBg,
          borderColor: 'transparent',
          borderRadius: theme.brandV2.borderRadius,
          color: theme.semantic.statusError,
          px: 1,
          py: 0.25,
          [`& .${alertClasses.message}`]: {
            fontSize: '12px',
            fontWeight: 500,
            py: 0.5,
          },
          [`& .${alertClasses.icon}`]: {
            color: theme.semantic.statusError,
            fontSize: '16px',
            mr: 1,
            py: 0.5,
          },
        },
      }}
      variant="outlined"
    >
      <Box sx={{ fontWeight: 600 }}>{message}</Box>

      <Box>
        {t('tread_agent.error.try_again')}{' '}
        <ButtonBase
          onClick={onStartNewChat}
          sx={{
            color: theme.semantic.statusError,
            fontSize: '12px',
            fontWeight: 500,
            textDecoration: 'underline',
            verticalAlign: 'baseline',
            '&:hover': { textDecoration: 'none' },
          }}
        >
          {t('tread_agent.error.start_new_chat')}
        </ButtonBase>
      </Box>
    </Alert>
  );
}
